export const MODIFY_PROFILE_REQUEST = 'MODIFY_PROFILE_REQUEST'
export const MODIFY_PROFILE_SUCCESS = 'MODIFY_PROFILE_SUCCESS'
export const MODIFY_PROFILE_FAILURE = 'MODIFY_PROFILE_FAILURE'

export const FETCH_PREFERENCES_REQUEST = 'FETCH_PREFERENCES_REQUEST'
export const FETCH_PREFERENCES_SUCCESS = 'FETCH_PREFERENCES_SUCCESS'
export const FETCH_PREFERENCES_FAILURE = 'FETCH_PREFERENCES_FAILURE'

export const REMOVE_PREFERENCE_REQUEST = 'REMOVE_PREFERENCE_REQUEST'
export const REMOVE_PREFERENCE_SUCCESS = 'REMOVE_PREFERENCE_SUCCESS'
export const REMOVE_PREFERENCE_FAILURE = 'REMOVE_PREFERENCE_FAILURE'
